var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { LocalizationService } from './localization.service';
import { tap, map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./localization.service";
var PaymentService = /** @class */ (function () {
    function PaymentService(http, baseUrl, locale) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.locale = locale;
        this.resultCallback = this.resultCallback.bind(this);
        this.closeCallback = this.closeCallback.bind(this);
        this.openCheckout = this.openCheckout.bind(this);
        this.apiUrl = this.baseUrl + "api/payment";
    }
    PaymentService.prototype.getKey = function () { };
    PaymentService.prototype.postPayment = function (paymentModel) {
        return this.http.post("" + this.apiUrl, paymentModel);
    };
    PaymentService.prototype.areBookingsComplete = function (userCertificationId) {
        return this.http.get(this.apiUrl + "/areBookingsComplete/" + userCertificationId);
    };
    /**
     * Ping the Paysafe server to see if it is up and ready.
     * Since we also need to the single-use api key wait until that is retrieved as well before sending status back.
     */
    PaymentService.prototype.checkStatus = function () {
        var _this = this;
        var status = this.http.get(this.apiUrl + "/status").pipe(tap(function (res) {
            if (res.status !== 'READY') {
                alert('The payment system is temporarily out of service.  Try again later.');
            }
        }));
        var key = this.http.get(this.apiUrl + "/key");
        return forkJoin([status, key]).pipe(tap(function (results) {
            _this.singleUseToken = results[1].key;
            _this.environment = results[1].env;
        }), map(function (results) { return results[0]; }));
    };
    /**
     * Configures and opens the Paysafe checkout popup dialog.  This will appear as a modal overlay on the screen.
     * Documentation: https://developer.paysafe.com/en/sdks/paysafe-checkout/overview/
     * Test credit card number: 4111 1111 1111 1111
     * More Test card numbers at: https://developer.paysafe.com/en/rest-apis/cards/test-and-go-live/test-cards/
     * @param paymentType The type of payment that is being made.
     * @param id The ID of the thing that's being paid for.  This will be used differently depending on the paymentType.
     * @param amount The amount that will be charged to the user's credit card.
     * @param holderName The name that appears on the credit card.
     * @param successMessageKey The message details needed to display to correct message once payment is complete. Ex: {key: '[keyFromLocalFile]', params: {}}
     * @param successCallback A function to call once payment is complete and the user clicks the close button at the end.
     */
    PaymentService.prototype.openCheckout = function (paymentType, id, amount, holderName, successMessageKey, successCallback) {
        return __awaiter(this, void 0, void 0, function () {
            var locale, options;
            return __generator(this, function (_a) {
                this.paymentType = paymentType;
                this.productId = id;
                this.successCallback = successCallback;
                this.successMessageKey = successMessageKey;
                this.amount = Math.round(amount * 100);
                // For Testing declined cards: https://developer.paysafe.com/en/rest-apis/cards/test-and-go-live/simulating-card-payments/
                // this.amount = parseInt(prompt('enter test amount')) || amount * 100;
                console.log('Paysafe environment:', this.environment);
                locale = this.locale.getLocale().includes('fr') ? 'fr_CA' : 'en_US';
                options = {
                    holderName: holderName,
                    locale: locale,
                    amount: this.amount,
                    currency: 'CAD',
                    // Options are: TEST and LIVE.  Paysafe default is LIVE, but here, we'll default to TEST.
                    environment: this.environment || 'TEST',
                    companyName: 'KortoJura',
                    imageUrl: 'https://tks-kortojura-dev.azurewebsites.net/assets/images/kortojura_logo_full_small.png',
                    buttonColor: '#9b3328',
                    preferredPaymentMethod: 'Cards',
                    displayPaymentMethods: ['Cards']
                };
                // Setup Documentation: https://developer.paysafe.com/en/sdks/paysafe-checkout/setup-function/#setup-function
                paysafe.checkout.setup(this.singleUseToken, options, this.resultCallback, this.closeCallback);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Called once we've received a one-time token from Paysafe or there was an error opening the iframe.
     * @param paysafeOverlayInstance The instance of the Paysafe dialog popup
     * @param error Information at errors that have occurred.
     * @param result If all is good, this will contain the one-time token that will be used to complete the payment.
     */
    PaymentService.prototype.resultCallback = function (paysafeOverlayInstance, error, result) {
        var _this = this;
        // console.log('resultCallback', { paysafeOverlayInstance, result, error });
        var lk = 'RegisterCertification.Payment.';
        var lke = 'RegisterCertification.Payment.Errors.';
        if (!error && result && result.token) {
            if (result.paymentMethod === 'Cards') {
                // use AJAX to send result.token to your merchant server to take CC payment
                this.postPayment({
                    token: result.token,
                    amount: this.amount,
                    paymentType: this.paymentType,
                    productId: this.productId
                }).subscribe(function (res) {
                    if (res.status === 'COMPLETED') {
                        var successMessage = _this.locale.instant("" + lk + _this.successMessageKey.key, _this.successMessageKey.params);
                        successMessage += _this.locale.instant(lk + "PurchasedEndMessage", {
                            email: res.profile.email,
                            authCode: res.authCode
                        });
                        paysafeOverlayInstance.showSuccessScreen(successMessage);
                    }
                    else {
                        if (res.error.code) {
                            // Max Paysafe error message length is 200 chars, so chop the email if it's too long.
                            var errorMessage = _this.locale.instant("" + lke + res.error.code);
                            if (errorMessage.includes('{{email}}')) {
                                var email = errorMessage.length + res.userEmail.length + 2 <= 200
                                    ? "(" + res.userEmail + ")"
                                    : '';
                                errorMessage = errorMessage.replace(/{{email}}/g, email);
                            }
                            paysafeOverlayInstance.showFailureScreen(errorMessage, _this.locale.instant(lke + "PurchaseErrorTitle"));
                        }
                        else {
                            paysafeOverlayInstance.showFailureScreen(_this.locale.instant(lke + "PurchaseError"), _this.locale.instant(lke + "PurchaseErrorTitle"));
                        }
                    }
                });
            }
            else if (result.paymentMethod === 'DirectDebit') {
                // use AJAX to send result.token to your merchant server to take DD payment
            }
            else if (result.paymentMethod === 'Interac') {
                // use AJAX to send result.token to your merchant server to take Interac payment
            }
            else if (result.paymentMethod === 'PayPal') {
                // use AJAX to send result.token to your merchant server to take PayPal payment
            }
        }
        else {
            // error handling
            switch (error.code) {
                case '9064':
                    // `Unable to launch the payment form.  Please try again later.\n\n${error.name} (${error.code})\n${error.detailedMessage}`
                    alert(this.locale.instant(lke + "Error9064", error));
                    break;
                default:
                    if (paysafeOverlayInstance && paysafeOverlayInstance.isOpen()) {
                        // `An error occurred while trying to make a payment.  No Payment was made. ${error.code}`,
                        paysafeOverlayInstance.showFailureScreen(this.locale.instant(lke + "Default", error), this.locale.instant(lke + "PaymentError"));
                    }
                    else {
                        alert(this.locale.instant(lke + "DefaultAlert", error));
                    }
            }
        }
    };
    /**
     * Called if the user closes the checkout popup/overlay.
     * @param stage The stage at which the popup was closed.
     */
    PaymentService.prototype.closeCallback = function (stage) {
        if (stage === 'BeforePayment') {
            // No payment has been made.
            alert(this.locale.instant("RegisterCertification.Payment.Errors.ClosedPrematurely"));
        }
        else if (stage === 'DuringPayment') {
            // Token have been issued, but the checkout overlay was closed by the user before instance flow control method was invoked.
            alert(this.locale.instant("RegisterCertification.Payment.Errors.ClosedPrematurely"));
        }
        else if (stage === 'AfterPayment') {
            // Closed either via paysafeOverlayInstance.close method or by the user from the success screen.
            // This the normal flow.
            if (this.successCallback) {
                this.successCallback();
            }
        }
        this.successCallback = undefined;
    };
    PaymentService.ngInjectableDef = i0.defineInjectable({ factory: function PaymentService_Factory() { return new PaymentService(i0.inject(i1.HttpClient), i0.inject("BASE_URL"), i0.inject(i2.LocalizationService)); }, token: PaymentService, providedIn: "root" });
    return PaymentService;
}());
export { PaymentService };
